<template>
    <v-bottom-navigation app fixed grow color="primary">
        <!-- Home -->
        <!-- <v-btn @click="goto('/')" :input-value="isActive('/')">
            <span>Home</span>
            <v-icon :color="isActive('/') ? 'primary' : ''">home</v-icon>
        </v-btn> -->

        <!-- Menu dinamico -->
        <v-btn v-for="(item, i) in menuDettaglio" :key="i" @click="goto(item.programPath)">
            <span>{{ item.descrizione }}</span>
            <v-icon :color="isActive(item.programPath) ? 'primary' : ''">{{ item.icon }}</v-icon>
        </v-btn>
    </v-bottom-navigation>
</template>

<script>
export default {
    computed: {
        menuDettaglio() {
            const menu = this.$store.getters["user/getMenu"];
            const dettaglio = menu?.menuDettaglio || [];
            if (this.isDesktopView) {
                localStorage.setItem('calendario_tipo_vista', 'list');
                return [];
            }
            return dettaglio;
        },
        activeItem() {
            return this.$route.path;
        },
        isDesktopView() {
            return this.$route.query.view === 'desktop';
        },
    },

    methods: {
        goto(path) {
            this.$emit("goto", path);
        },

        isActive(path) {
            return this.$route.path === path;
        }
    },
};
</script>
